module.exports = __webpack_public_path__ + "static/WelcomeToElk8-661982bb72d28fac3c7a5d64358f7c69.webp";